import { render } from "./generalLedger.vue?vue&type=template&id=750bbfd2&scoped=true"
import script from "./generalLedger.vue?vue&type=script&lang=js"
export * from "./generalLedger.vue?vue&type=script&lang=js"

import "./generalLedger.vue?vue&type=style&index=0&id=750bbfd2&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750bbfd2"]])

export default __exports__